"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripMetaExpressionKey = exports.parseRawMetaExpression = void 0;
exports.stripMetaExpression = stripMetaExpression;
const types_1 = require("../types");
/**
 * Converts a string meta expr into a meta expression object
 * @param rawMetaExpr can be either a meta expr (ex: '__active_workflow_report/__step:lrklxfjntcgllspl/__custom_field:phone')
 * or a meta expression surrended by ${..} (ex: '${__active_workflow_report/__step:lrklxfjntcgllspl/__custom_field:phone}')
 * @returns
 */
const parseRawMetaExpression = (rawMetaExpr) => {
    let rawMetaExpression = rawMetaExpr;
    rawMetaExpression = stripMetaExpression(rawMetaExpr);
    let target_type;
    let target_content;
    if (!rawMetaExpr.includes("__active_")) {
        target_content = rawMetaExpression;
        target_type = types_1.META_EXPRESSION_TARGET_TYPE.SQL;
        return {
            target_type: target_type,
            target_content: target_content
        };
    }
    else {
        target_type = types_1.META_EXPRESSION_TARGET_TYPE.VARIABLE;
    }
    const [rawBody, defaultValue] = rawMetaExpression.split("|");
    const rawScope = rawBody.split("/")[0];
    let scope = undefined;
    switch (rawScope) {
        case "__active_client":
            scope = types_1.META_EXPRESSION_SCOPE.CLIENT;
            break;
        case "__active_customer":
            scope = types_1.META_EXPRESSION_SCOPE.CUSTOMER;
            break;
        case "__active_item":
            scope = types_1.META_EXPRESSION_SCOPE.ITEM;
            break;
        case "__active_user":
            scope = types_1.META_EXPRESSION_SCOPE.USER;
            break;
        case "__active_workflow_report":
            scope = types_1.META_EXPRESSION_SCOPE.WORKFLOW_REPORT;
            break;
        case "__active_integ_record":
            scope = types_1.META_EXPRESSION_SCOPE.INTEG_RECORD;
            break;
        case "__active_activity_report":
            scope = types_1.META_EXPRESSION_SCOPE.ACTIVITY_REPORT;
            break;
        case "__active_job_report":
            scope = types_1.META_EXPRESSION_SCOPE.JOB_REPORT;
            break;
        case "__active_item_cell":
            scope = types_1.META_EXPRESSION_SCOPE.ITEM_CELL;
            break;
        case "__active_matrix_cell":
            scope = types_1.META_EXPRESSION_SCOPE.MATRIX_CELL;
            break;
        case "__active_trigger_event":
            scope = types_1.META_EXPRESSION_SCOPE.TRIGGER_EVENT;
            break;
    }
    const metaExpression = Object.assign(Object.assign(Object.assign({}, (scope && { scope })), (defaultValue && { default_value: defaultValue })), (target_type && { target_type }));
    rawBody.split("/").forEach((part) => {
        const rawKeys = part.split(":");
        if (rawKeys.length > 1) {
            const fieldName = (0, exports.stripMetaExpressionKey)(rawKeys[0]);
            const fieldValue = rawKeys[1];
            if (fieldName === "custom_field") {
                if (metaExpression.hasOwnProperty("custom_field2")) {
                    metaExpression.custom_field3 = fieldValue;
                }
                else if (metaExpression.hasOwnProperty("custom_field1")) {
                    metaExpression.custom_field2 = fieldValue;
                }
                else {
                    metaExpression.custom_field1 = fieldValue;
                }
                return;
            }
            metaExpression[fieldName] = fieldValue;
        }
    });
    // if (metaExpression.field?.startsWith("_") && metaExpression.scope? IN [META_EXPRESSION_SCOPE.USER, META_EXPRESSION_SCOPE.CLIENT]) {
    //   metaExpression.field = metaExpression.field!.slice(1);
    // }
    return metaExpression;
};
exports.parseRawMetaExpression = parseRawMetaExpression;
const stripMetaExpressionKey = (rawKey) => {
    return rawKey.split("__")[1];
};
exports.stripMetaExpressionKey = stripMetaExpressionKey;
exports.default = exports.parseRawMetaExpression;
function stripMetaExpression(me) {
    return me
        .trim()
        .replace(/^\$/, "")
        .replace(/^{/, "")
        .replace(/^</, "")
        .replace(/^\^/, "")
        .replace(/}$/, "")
        .replace(/>$/, "")
        .replace(/\^$/, "");
}
